import Card from '../components/Card'
import useFetch from '../hooks/useFetch';
import Loading from '../components/Loading';

const IndexPage = ({label}) => {
  const [data, loading] = useFetch((label === 'Projects' ? '/projects' : '/articles'));

  return (
    <div>
      <h3 className='container-title'>My {label}</h3>
      {loading? <Loading /> :
        (<div className='project__container'>
          {data === null ? '': data.map(project => (
            <Card key={project.id} id={project.id} image_url={project.image_url} label={label} title={project.title} status_description={project.short_description} status={project.project_type} hashtag={project.project_type} />
          ))}
        </div>)
      }
    </div>
  );
}

export default IndexPage